import type { NavigationItem } from './navigationTypes';

/**
 * Provide a more-or-less unique and stable key for a `NavigationItem`, as they unfortunately have no guaranteed unique identifier.
 */
export const getNavigationItemKey = (item: NavigationItem) => `${item.categoryId}_uri_${item.uri}`;
